import request from '../../utils/request'

//初始化店铺
export function addNewStore(data) {
    return request({
        url: '/setting/eshop/config/initStore',
        method: 'post',
        data
    })
}
//初始化店铺之后的传值
export function initSmartStore(data) {
    return request({
        url: '/product/eshop/tas/secondary/initSmartStore',
        method: 'get',
        params:data
    })
}

//店铺设置的修改
export function updateShopSetting(data) {
    return request({
        url: '/setting/eshop/config/updateSingleSetting',
        // url:'/auth/account/storeInfoSetting',
        method: 'post',
        data
    })
}
// 店铺设置查询 /setting/eshop/config/queryStoreSetting
export function queryShopSetting(data) {
    return request({
        url: '/setting/eshop/config/queryStoreSetting',
        method: 'get',
        data
    })
}

// 店铺管理-店铺设置 查询 修改
export function storeInfoSetting(data) {
    return request({
        url:'/auth/personal/storeInfoSetting',
        method: 'post',
        data
    })
}
export function storeInfoShow(data) {
    return request({
        url:'/auth/personal/storeInfoShow',
        method: 'get',
    })
}

//克隆列表  /setting/eshop/config/cloneList
export function cloneList(data) {
    return request({
        url: '/setting/eshop/config/cloneList',
        method: 'post',
        data
    })
}

//查询机构
export function storeList(params) {
    return request({
        url: '/auth/account/storeList',
        method: 'get',
        params
    })
}

//切换机构
export function changeOrg(data) {
    return request({
        url: '/auth/account/changeOrg',
        method: 'post',
        data
    })
}

//预览 我的店铺
export function getBanner(data) {
    return request({
        url: '/setting/eshop/mini/banner',
        method: 'get',
    })
}

//预览 品牌自营专区产品
export function zoneProductPool(data) {
    return request({
        url: '/product/eshop/tas/zoneProductPool',
        method: 'post',
        data
    })
}
//主题 
export function themeOrderBy() {
    return request({
        url: '/product/eshop/tas/themeOrderBy',
        method: 'get',
    })
}

//店铺二维码
export function getORCode(data) {
    return request({
        url: '/external/sns/getORCode',
        method: 'post',
        data
    })
}



// WEBPACK FOOTER //
// ./src/TASMini/api/shop.js